import React from 'react';
import { 
  Grid, 
  Card, 
  CardContent, 
  Box, 
  Skeleton,
  keyframes 
} from '@mui/material';

// Shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const SpaceCardSkeleton = () => {
  return (
    <Card
      sx={{
        maxHeight: '460px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        borderRadius: '16px',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
      }}
    >
      {/* Gallery Section Skeleton */}
      <Box sx={{
        position: 'relative',
        height: '200px',
      }}>
        <Box 
          sx={{
            height: '100%',
            width: '100%',
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
            backgroundSize: '200% 100%',
            animation: `${shimmer} 1.5s infinite ease-in-out`,
          }}
        />
      </Box>

      <CardContent sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        p: 2,
        pt: 1.5,
        '&:last-child': { pb: 2 }
      }}>
        {/* Venue Name Skeleton */}
        <Skeleton 
          variant="text" 
          width="75%" 
          height={26} 
          animation="wave" 
          sx={{ 
            mb: 0.5,
            borderRadius: '4px',
          }} 
        />

        {/* Address Skeleton */}
        <Skeleton 
          variant="text" 
          width="90%" 
          height={22} 
          animation="wave"
          sx={{ borderRadius: '4px' }}
        />
      </CardContent>

      {/* Week Grid Skeleton */}
      <Box sx={{ p: 1.5, pt: 0 }}>
        <Grid container spacing={0.5}>
          {Array(5).fill(0).map((_, index) => (
            <Grid item xs={2.4} key={index}>
              <Box
                sx={{
                  height: 56,
                  borderRadius: '8px',
                  background: 'linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)',
                  backgroundSize: '200% 100%',
                  animation: `${shimmer} 1.5s infinite ease-in-out`,
                  animationDelay: `${index * 0.1}s`,
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Card>
  );
};

const LoadingCardPlaceholder = ({ count = 8, isMapVisible = false }) => {
  return (
    <Grid
      container
      spacing={3}
      columns={{ xs: 12, md: 12, xl: 12 }}
    >
      {Array(count).fill(0).map((_, index) => (
        <Grid
          item
          xs={12}
          md={isMapVisible ? 6 : 4}
          xl={isMapVisible ? 6 : 3}
          key={index}
          sx={{
            minWidth: '300px',
            transition: 'all 0.3s ease',
          }}
        >
          <SpaceCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
};

export default LoadingCardPlaceholder;